import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "dlg-common-center-ctn"
};
var _hoisted_2 = {
  class: "header"
};
var _hoisted_3 = {
  key: 0,
  class: "title"
};
var _hoisted_4 = {
  class: "content"
};
var _hoisted_5 = {
  key: 0,
  class: "desc"
};
var _hoisted_6 = {
  key: 0,
  class: "bottom"
};
import { ref, computed } from "vue";
import { Popup } from "vant";
import Button from "@/components/base/Button.vue";
import { isFunction } from "@/utils/isUtil";
export default {
  __name: 'CommonCenter',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    onOk: {
      type: Function,
      default: null
    },
    onCancel: {
      type: Function,
      default: null
    },
    okText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    withoutCancel: {
      type: Boolean,
      default: false
    },
    showBottomButton: {
      type: Boolean,
      default: true
    },
    disableOkButton: {
      type: Boolean,
      default: false
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:visible"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var show = computed({
      get: function get() {
        return props.visible;
      },
      set: function set(val) {
        emits("update:visible", val);
      }
    });
    var noloading = ref(false);
    var yesloading = ref(false);
    function ok() {
      return _ok.apply(this, arguments);
    }
    function _ok() {
      _ok = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!noloading.value) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (!isFunction(props.onOk)) {
                _context.next = 7;
                break;
              }
              yesloading.value = true;
              _context.next = 7;
              return props.onOk();
            case 7:
              _context.prev = 7;
              yesloading.value = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0,, 7, 10]]);
      }));
      return _ok.apply(this, arguments);
    }
    function cancel(_x) {
      return _cancel.apply(this, arguments);
    }
    function _cancel() {
      _cancel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(type) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!yesloading.value) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!isFunction(props.onCancel)) {
                _context2.next = 9;
                break;
              }
              noloading.value = true;
              _context2.next = 7;
              return props.onCancel(type);
            case 7:
              _context2.next = 10;
              break;
            case 9:
              show.value = false;
            case 10:
              _context2.prev = 10;
              noloading.value = false;
              return _context2.finish(10);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0,, 10, 13]]);
      }));
      return _cancel.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(Popup), {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return show.value = $event;
        }),
        round: "",
        style: {
          width: '2.95rem'
        },
        "close-on-click-overlay": __props.closeOnClickOverlay
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [__props.desc ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.desc), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "content")]), __props.showBottomButton ? (_openBlock(), _createElementBlock("div", _hoisted_6, [!__props.withoutCancel ? (_openBlock(), _createBlock(Button, {
            key: 0,
            type: "border",
            class: "btn btn-cancel",
            onClick: cancel
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(__props.cancelText || _ctx.$t("no")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(Button, {
            class: "btn btn-confirm",
            disabled: __props.disableOkButton,
            onClick: ok
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(__props.okText || _ctx.$t("yes")), 1)];
            }),
            _: 1
          }, 8, ["disabled"])])) : _createCommentVNode("", true)])];
        }),
        _: 3
      }, 8, ["show", "close-on-click-overlay"]);
    };
  }
};